import { render, staticRenderFns } from "./SecurityWatermark.vue?vue&type=template&id=6ab98862&scoped=true"
import script from "./SecurityWatermark.vue?vue&type=script&lang=js"
export * from "./SecurityWatermark.vue?vue&type=script&lang=js"
import style0 from "./SecurityWatermark.vue?vue&type=style&index=0&id=6ab98862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab98862",
  null
  
)

export default component.exports